import { render, staticRenderFns } from "./CancelClassroom.vue?vue&type=template&id=2d0fa882&scoped=true"
import script from "./CancelClassroom.vue?vue&type=script&lang=js"
export * from "./CancelClassroom.vue?vue&type=script&lang=js"
import style0 from "./CancelClassroom.vue?vue&type=style&index=0&id=2d0fa882&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0fa882",
  null
  
)

export default component.exports